import envDetect from '@tcc/env-detect';

export const ROOT = envDetect.getEnvHostname(envDetect.getCurrentEnv());
export const HOST_NAME = `https://${ROOT}/static`;
